import { EnumList } from 'common/constants/enum';
import { FormState, Input } from 'components/elements';
import { CustomLabel } from 'components/elements/custom-form-control';
import EnumSelectInput from 'legacy-modules/master/select-input/enum';
import { FullContainer, SeparatorHorizontal } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function UserNameField({
  titleClass = EnumList.GuestTitleType,
}: {
  titleClass?: EnumList.TitleType | EnumList.GuestTitleType;
}) {
  const { t } = useTranslation();
  return (
    <FormState>
      {({ editable }) => (
        <FullContainer>
          <CustomLabel label={t('common:name')} disabled={!editable} required />
          <FullContainer style={styles.container}>
            <div style={styles.leftContent}>
              <EnumSelectInput
                name="title"
                placeholder={t('common:title_text')}
                enumType={titleClass}
                hideRequiredStar
                overrides={{
                  Root: {
                    style: { width: '100px' },
                  },
                }}
              />
            </div>
            <SeparatorHorizontal $margin={24} />
            <div style={styles.rightContent}>
              <Input
                type="text"
                name="name"
                placeholder={t('common:name')}
                required
                hideRequiredStar
                fontCase="TitleCase"
              />
            </div>
          </FullContainer>
        </FullContainer>
      )}
    </FormState>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftContent: {
    maxWidth: 100,
  },
  rightContent: {
    width: '100%',
  },
};
